'use client';

import { recordError } from '@firebase/crashlytics';
import { getCrashlytics } from '../../lib/firebase';

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
}) {
  // We need to explicitly capture the error here, since this logic is analagous to a try-catch
  // block (ie. the error will not bubble up to the FirebaseCrashlytics boundary). This block may be
  // hit more than once while in development mode.
  console.info(
    'about to capture error in crashclient/error.tsx and show fallback UI'
  );
  recordError(getCrashlytics(), error);

  return (
    <div>
      <h2>Oopsies! Something went wrong. Check your logs, yo!</h2>
    </div>
  );
}